import PropTypes from "prop-types";
import { isNil } from "ramda";

import Presenter from "utils/PropTypesPresenter";
import InvitePresenter from "presenters/InvitePresenter";
import MakePresenter from "presenters/MakePresenter";
import TemplatePresenter from "presenters/TemplatePresenter";
import { ECARD_TYPES } from "enums";

export default new Presenter(
  {
    type: PropTypes.string,
  },
  {
    templateId(ecard, template) {
      if (isNil(ecard)) return "";
      if (this.isMake(ecard)) return TemplatePresenter.id(template);
      return InvitePresenter.templateId(ecard);
    },
    templateGroupId(ecard) {
      return this.isMake(ecard) ? MakePresenter.templateGroupId(ecard) : InvitePresenter.templateGroupId(ecard);
    },
    template(ecard) {
      return MakePresenter.template(ecard);
    },
    isMake(ecard) {
      return this.type(ecard) === ECARD_TYPES.MAKE;
    },
  },
);
